import React from "react";
import { NavLink } from "react-router-dom";

import Icon from "../UI/Icon";

const NavigationPanelCategory = (props) => {
  // console.log("[NavigationMenuCategory]: ", props.cvPart);

  let cvPartTitle = Object.keys(props.cvPart)[0];

  let cvSections = props.cvPart[cvPartTitle];
  cvSections = cvSections.map((section) => (
    <NavLink
      key={section.id}
      // to={cvPartTitle + "#" + section.id}
      to={{ pathname: cvPartTitle, hash: section.id }}
      exact
      isActive={(match, location) => location.hash === "#" + section.id}
      className="nav-panel-items__item"
      activeClassName="nav-item-active"
      onClick={() => props.appNavState.clicked()}
    >
      _ {section.menuTitle ? section.menuTitle : section.title}
    </NavLink>
  ));

  let icon = <Icon iconName={props.cvPart.icon} />;

  return (
    <li className="nav-panel__part">
      <NavLink
        to={cvPartTitle}
        exact
        className="nav-panel-part__icon"
        activeClassName="nav-item-active"
        onClick={() => props.appNavState.clicked()}
      >
        {icon}
      </NavLink>
      <div className="nav-panel-part__items">
        <NavLink
          to={cvPartTitle}
          exact
          className="nav-panel-part__title"
          activeClassName="nav-item-active"
          onClick={() => props.appNavState.clicked()}
        >
          {cvPartTitle}
        </NavLink>
        {cvSections}
      </div>
    </li>
  );
};

export default NavigationPanelCategory;
